import { useTranslation } from 'react-i18next';
import type { ProductStockListings } from 'types/capi/pdp';

import WtbToggleViewEvent from '~/events/WtbToggleViewEvent';
import useRootData from '~/hooks/useRootData';
import type { TrackedButtonClickName } from '~/services/gtm.client';

import ViewTab from '../../components/WhereToBuy/ViewTab';
import { SelectedView } from './index';

type Props = {
  selectedView: SelectedView;
  setSelectedView: (view: SelectedView) => void;
  stockListings: ProductStockListings;
};

export default function ViewToggle({
  selectedView,
  setSelectedView,
  stockListings
}: Props) {
  const { t } = useTranslation('pdp');

  const { RAFFLES, RETAILERS, MINIMISED } = SelectedView;

  const numOfRaffles = stockListings.raffles.length;
  const numOfRetailers = stockListings.affiliates.length;

  if (numOfRetailers === 0 && numOfRaffles === 0) return null;

  const showsBothTabs = numOfRetailers > 0 && numOfRaffles > 0;

  return (
    <div
      className={`flex w-full gap-2 ${showsBothTabs ? '' : 'justify-center'}`}
    >
      {numOfRetailers > 0 && (
        <Toggle
          isSelected={selectedView === RETAILERS}
          onClick={() =>
            setSelectedView(selectedView === RETAILERS ? MINIMISED : RETAILERS)
          }
          name="SHOW_ALL_RETAILERS"
          stretch={showsBothTabs}
          shortLabel={t('retailers')}
        >
          {t('showRetailersButton', { numOfRetailers })}
        </Toggle>
      )}
      {numOfRaffles > 0 && (
        <Toggle
          isSelected={selectedView === RAFFLES}
          onClick={() =>
            setSelectedView(selectedView === RAFFLES ? MINIMISED : RAFFLES)
          }
          name="SHOW_ALL_RAFFLES"
          stretch={showsBothTabs}
          shortLabel={t('raffles')}
        >
          Show all raffles
        </Toggle>
      )}
    </div>
  );
}

function Toggle({
  onClick,
  children,
  isSelected,
  name,
  shortLabel,
  stretch
}: {
  children: string;
  isSelected: boolean;
  name: TrackedButtonClickName;
  onClick: () => void;
  shortLabel: string;
  stretch: boolean;
}) {
  const { isBot } = useRootData();

  return (
    <ViewTab
      isSelected={isSelected}
      name={name}
      shortLabel={shortLabel}
      stretch={stretch}
      onClick={() => {
        onClick();

        return new WtbToggleViewEvent({
          isBot,
          trackedButtonName: name
        }).send();
      }}
    >
      {children}
    </ViewTab>
  );
}
